

















































import { defineComponent, ref, PropType, computed, useFetch, useContext } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useStore } from '~/composables/useStore';
import { useWOVNio } from '~/composables/wovn/useWOVNio';
import { SMARTPHONE } from '~/constants/breakpoint';
import { url } from '~/utils';
import { ProductShowECResponseSchema } from '~/types/modules/product';
import { ProductCategoryId, DisplayLang } from '~/enums';

type ProducerIntro = {
  pcImage?: string;
  spImage?: string;
  name?: string;
  nameEn?: string;
  caption?: string;
  description?: string;
};

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
    AppLink,
  },
  props: {
    ecResponse: {
      type: Object as PropType<ProductShowECResponseSchema>,
      required: true,
    },
    hasLink: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const store = useStore();
    const { app } = useContext();
    const { currentLang } = useWOVNio();
    const isBrand = computed(() => {
      const category = props.ecResponse.categories[0]?.id || ProductCategoryId.WINE;
      return [ProductCategoryId.WINE_CELLAR, ProductCategoryId.WINE_GOODS, ProductCategoryId.FOOD].includes(category);
    });
    const producerId = computed(() => props.ecResponse.master_settings?.producer?.id);
    const link = computed(() => producerId.value && url('PRODUCER_DETAIL', { id: producerId.value }));
    const data = ref<ProducerIntro>();
    const isSmartPhone = ref(app.$ua.deviceType() === SMARTPHONE);

    useFetch(async () => {
      try {
        if (!producerId.value) {
          return;
        }
        const result = await store.dispatch('modules/content/fetchProducerForItemDetail', { id: producerId.value });
        data.value = {
          pcImage: result?.main_image_pc_s,
          spImage: result?.main_image_sp_s,
          name: result?.producer_name_s,
          nameEn: result?.producer_name_english_s,
          caption: result?.short_caption_t,
          description: result?.short_description_t,
        };
      } catch {
        // 何もしない
      }
    });
    const hasNoContent = computed(() => !data.value?.pcImage && !data.value?.caption && !data.value?.description);

    const isShownProducerNameJa = computed(() => !data.value?.nameEn || currentLang.value.code === DisplayLang.JA);

    return {
      isBrand,
      link,
      data,
      hasNoContent,
      isShownProducerNameJa,
      isSmartPhone,
    };
  },
});
